module.exports = __webpack_public_path__ + "img/helloThere.bbaa8b72.png";